import { render, staticRenderFns } from "./SurfaceDesignPrintPlacement.vue?vue&type=template&id=064d284e"
import script from "./SurfaceDesignPrintPlacement.vue?vue&type=script&lang=js"
export * from "./SurfaceDesignPrintPlacement.vue?vue&type=script&lang=js"
import style0 from "./SurfaceDesignPrintPlacement.vue?vue&type=style&index=0&id=064d284e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports